import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const sources = [
  {
    icon: 'ri-global-line',
    title: 'Публичные тематические площадки',
    desc: 'Анализируем открытые обсуждения, сообщества и запросы, где люди ищут решение, подрядчика или поставщика.',
  },
  {
    icon: 'ri-spy-line',
    title: 'Аудитория конкурентов',
    desc: 'Собираем тех, кто заходил на сайты конкурентов или звонил им — это люди с готовым спросом на ваш продукт.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Сегменты по намерению',
    desc: 'Собираем аудитории по географии, интересам, потребности и этапу выбора.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Ваша база клиентов',
    desc: 'Реактивируем «спящие» заявки и клиентов, по которым есть согласие на коммуникацию.',
  },
];

export default function LTKSources() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(4);
  const { ref: noteRef, revealed: noteRevealed } = useScrollReveal({ delay: 200 });

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Источники
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Находим людей, которые уже выбирают ваш продукт
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {sources.map((item, i) => (
            <div
              key={item.title}
              className={`rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-7 hover:border-primary-500/40 transition-all duration-300 group reveal-fade-up ${i < cardsRevealed ? 'revealed' : ''}`}
              style={i < cardsRevealed ? { transitionDelay: `${i * 120}ms` } : undefined}
            >
              <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600 mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="font-display font-bold text-[17px] text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-[14.5px] text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <p ref={noteRef} className={`mt-10 text-center text-[14px] text-foreground-500 max-w-2xl mx-auto reveal-fade-up ${noteRevealed ? 'revealed' : ''}`}>
          Работаем с открытыми источниками, разрешёнными рекламными инструментами и контактами с законным основанием для коммуникации.
        </p>
      </div>
    </section>
  );
}